module.exports = __webpack_public_path__ + "media/images/fonts/Feather-e103929dd758126ea4a090ff0e33b620f3ceb1b81ffad1345023c95661c84d8c.ttf";